import { useEffect } from 'react';

import { Stage } from '@eventbrite/webapp-constants';

import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';
import { useIsPreview } from '@/components/_shared/contexts/PreviewContext';

import { isEventEnded } from '../../utils/bodyUtils';
import { useTrackingBeacons } from '../useTrackingBeacons/';

import { pixelsTracking } from './pixelsTracking';

export const useTrackingPixels = ({ stage }: { stage: Stage }) => {
  const isPreview = useIsPreview();
  const { id: eventId, organizationId, isProtected, status } = useBasicInfo();
  const [trackingBeacons] = useTrackingBeacons();

  useEffect(() => {
    if (isPreview || isProtected || isEventEnded(status)) {
      return;
    }
    if (trackingBeacons) {
      let environment;
      if (stage === Stage.PROD) {
        environment = 'prod';
      } else if (stage === Stage.TEST) {
        environment = 'qa';
      } else {
        environment = 'dev';
      }
      const debugging = stage !== Stage.PROD && process.env.NEXT_PUBLIC_TRACKING_PIXEL_DEBUG === 'true';

      pixelsTracking({
        eventId,
        organizationId,
        environment,
        debugging,
        trackingBeacons,
      });
    }
    // isPreview is stable for the component's lifetime; only trackingBeacons can change at runtime
  }, [trackingBeacons, isPreview]); // eslint-disable-line react-hooks/exhaustive-deps
};
